import { NavigationSidebar } from "fleet/view/navigation/sidebar";
import { connect } from "react-redux";
import * as Auth from "redux-store/auth/selectors";
import { calcDeviceStatsSelector } from "redux-store/device-stats/selectors";
import * as FeatureFlags from "redux-store/feature-flags/selectors";

function mapStateToProps(state, props) {
  const { location } = props;
  const { pathname } = location;
  const user = Auth.getAuthUser(state);
  const deviceStatusCount = calcDeviceStatsSelector(state);
  const featureFlags = FeatureFlags.getFeatureFlags(state);

  return {
    deviceStatusCount,
    user,
    activePath: pathname,
    featureFlags,
  };
}

const ConnectedNavigationSidebar = connect(mapStateToProps)(NavigationSidebar);

export { ConnectedNavigationSidebar };
